import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { showSnackbar } from 'fluxo-ui';
import { BlockLoading } from '../components/Loading';
import { QuestionEditor } from '../components/question';
import questionService from '../services/question.service';

const QuestionEditPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [question, setQuestion] = useState<any | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            loadQuestion();
        }
    }, [id]);

    const loadQuestion = async () => {
        try {
            setLoading(true);
            const data = await questionService.getQuestion(id!);
            setQuestion(data);
        } catch (error: any) {
            showSnackbar(error.message || 'Failed to load question', 'Error', { type: 'error' });
            navigate('/questions');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (questionData: any, _action: 'draft' | 'publish') => {
        const updated = await questionService.updateQuestion(id!, questionData);
        setQuestion(updated);
    };

    const handleArchive = async (_question: any): Promise<any> => {
        const archived = await questionService.archiveQuestion(id!);
        setQuestion(archived);
        return archived;
    };

    const handleValidateAI = async (_question: any) => {
        return await questionService.validateWithAI(id!);
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center py-12">
                <BlockLoading text="Loading question..." />
            </div>
        );
    }

    if (!question) {
        return (
            <div className="text-center py-12">
                <p className="text-slate-600 dark:text-slate-400">Question not found</p>
            </div>
        );
    }

    return (
        <div className="max-w-7xl mx-auto">
            <QuestionEditor
                question={question}
                onSave={handleSave}
                onCancel={() => navigate('/questions')}
                onArchive={handleArchive}
                onValidateAI={handleValidateAI}
            />
        </div>
    );
};

export default QuestionEditPage;
